export const PatternList =  [
  {'name' : '솔리드', 'value' : 1},
  {'name' : '좁은체크','value' : 2},
  {'name' : '중간체크','value' : 3},
  {'name' : '넓은체크','value' : 4},
  {'name' : '가로 스트라이프', 'value' : 5},
  {'name' : '세로 스트라이프','value' : 6},
  {'name' : '헤링본','value' : 7},
  {'name' : '넓은 프린트','value' : 8},
  {'name' : '좁은 프린트','value' : 9},
  {'name' : '포인트 프린트','value' : 10},
  {'name' : '배색','value' : 11},
  {'name' : '기타','value' : 12},
];

export const FitList = [
    {'name' : '와이드핏', 'value' : 1},
    {'name' : '레귤러핏','value' : 2},
    {'name' : '슬림핏','value' : 3},
];

export const SeasonList = [
    {'name' : '여름', 'value' : 1},
    {'name' : '겨울','value' : 2},
    {'name' : '사계절','value' : 3},
    {'name' : '봄/가을','value' : 4},
    {'name' : '봄/가을/겨울', 'value' : 5},
    {'name' : '봄/여름/가을', 'value' : 6},
];

export const ColorList = [
    {'name' : '빨강', 'value' : 1},
    {'name' : '노랑','value' : 2},
    {'name' : '초록','value' : 3},
    {'name' : '파랑','value' : 4},
    {'name' : '남색', 'value' : 5},
    {'name' : '보라','value' : 6},
    {'name' : '갈색','value' : 7},
    {'name' : '회색','value' : 8},
    {'name' : '흰색','value' : 9},
    {'name' : '큰 검정','value' : 10},
];

export const ToneList = [
    {'name' : '다크', 'value' : 1},
    {'name' : '라이트','value' : 2},
    {'name' : '미디움','value' : 3},
];

export const GenderList = [
    {'name' : '유니섹스', 'value' : 0},
    {'name' : '남자','value' : 1},
    {'name' : '여자','value' : 2},
];

export const BottomList = [
    {'name' : 'NONE', 'value' : 1},
    {'name' : '바지','value' : 2},
    {'name' : '스커트','value' : 3},
];

export const cateWomanFilter = {
    "outer": {
        name: 'OUTER',
        value: 'outer',
        subInfo: '(코트, 패딩, 외 겨울 아우터)',
        subCate: {
            "1": {
                "name": "롱코트",
                "value": 1,
                "filterValue": {
                    "category.level4": [
                        537, 646, 814, 1409, 1511, 2424,
                        538, 647, 815, 1410, 1512, 2425,
                        540, 649, 821, 1408, 1514, 2427,
                        650, 1407, 1515, 2428,
                        651, 2018, 2429,
                        652, 816, 1334, 2430,
                        653, 817, 2020, 2431,
                        541, 654, 1516, 2432,
                        542, 655, 819, 1517, 2433,
                        543, 656, 818, 1518, 2434,
                    ]
                }
            },
            "2": {
                "name": "간절기코트",
                "value": 2,
                "filterValue": {
                    "category.level4": [
                        539, 648, 820, 1513, 2426,
                        1492, 1493, 1411, 1519, 2435,
                    ]
                }
            },
            "3": {
                "name": "숏코트",
                "value": 3,
                "filterValue": {
                    "category.level4": [
                        544, 657, 829, 1413, 1520, 2436,
                        545, 658, 825, 1412, 1521, 2437,
                        546, 659, 826, 1522, 2438,
                        660, 828, 2439,
                        662, 824, 1524,
                        661, 1523, 2440,
                        547, 663, 827, 1525,
                        822,
                    ]
                }
            },
            "4": {
                "name": "롱패딩",
                "value": 4,
                "filterValue": {
                    "category.level4": [
                        665, 1415, 1336, 1527, 2033, 2198, 2444,
                        548, 666, 2448,
                    ]
                }
            },
            "5": {
                "name": "숏패딩",
                "value": 5,
                "filterValue": {
                    "category.level4": [
                        668, 831, 1417, 1337, 1529, 2036, 2201, 2447,
                        550, 669, 2199, 2445,
                    ]
                }
            },
            "6": {
                "name": "겨울점퍼",
                "value": 6,
                "filterValue": {
                    "category.level4": [
                        664, 1414, 1335, 1526, 2032, 2197, 2443,
                        549, 667, 830, 1416, 1528, 2035, 2200, 2446,
                    ]
                }
            },
            "7": {
                "name": "롱가디건",
                "value": 7,
                "filterValue": {
                    "category.level4": [
                        551, 671, 1531, 2039, 2450,
                    ]
                }
            },
            "8": {
                "name": "무스탕",
                "value": 8,
                "filterValue": {
                    "category.level4": [
                        670, 1530, 2449,
                        552, 672, 1418, 1338, 1532, 2451,
                    ]
                }
            }
        }

    },
    "top": {
        name: 'TOP',
        value: 'top',
        subInfo: '(자켓, 가디건, 블루종, 트러커)',
        subCate: {
            "1": {
                "name": "블레이저",
                "value": 1,
                "filterValue": {
                    "category.level4": [
                        834, 1419,
                        833,
                        554, 677, 836, 1339, 1542, 2456,
                        555, 676, 835, 1541, 2455,
                    ]
                }
            },
            "2": {
                "name": "트위드자켓",
                "value": 2,
                "filterValue": {
                    "category.level4": [
                        553
                    ]
                }
            },
            "3": {
                "name": "플랫카라자켓",
                "value": 3,
                "filterValue": {
                    "category.level4": [
                        556, 678, 837, 1543, 2457,
                    ]
                }
            },
            "4": {
                "name": "라이더자켓",
                "value": 4,
                "filterValue": {
                    "category.level4": [
                        557, 673, 832, 1538, 2452,
                    ]
                }
            },
            "5": {
                "name": "필드자켓",
                "value": 5,
                "filterValue": {
                    "category.level4": [
                        675, 1420, 1340, 1540, 2454,
                        674, 1421, 1539, 2042, 2453,
                        1422,
                    ]
                }
            },
            "6": {
                "name": "블루종",
                "value": 6,
                "filterValue": {
                    "category.level4": [
                        684, 1424, 1346, 1549, 2463,
                        558, 679, 838, 1423, 1341, 1544, 2047, 2458,
                    ]
                }
            },
            "7": {
                "name": "점퍼",
                "value": 7,
                "filterValue": {
                    "category.level4": [
                        681, 1425, 1343, 1546, 2053, 2219, 2460,
                        680, 1342, 1545, 2048, 2213, 2459,
                        686, 1348, 1551, 2218,
                    ]
                }
            },
            "8": {
                "name": "플리스",
                "value": 8,
                "filterValue": {
                    "category.level4": [
                        683, 1345, 1548, 2051, 2216, 2462,
                    ]
                }
            },
            "9": {
                "name": "아노락",
                "value": 9,
                "filterValue": {
                    "category.level4": [
                        1428, 1349,
                    ]
                }
            },
            "10": {
                "name": "트러커",
                "value": 10,
                "filterValue": {
                    "category.level4": [
                        685, 1427, 1347, 1550,
                    ]
                }
            },
            "11": {
                "name": "집업후드",
                "value": 11,
                "filterValue": {
                    "category.level4": [
                        682, 1426, 1344, 1547, 2050, 2215, 2461,
                    ]
                }
            },
            "12": {
                "name": "가디건",
                "value": 12,
                "filterValue": {
                    "category.level4": [
                        559, 687, 839, 1429, 1350, 1552, 2055, 2220, 2466,
                        688, 1553, 2467,
                    ]
                }
            },
            "13": {
                "name": "집업조끼",
                "value": 13,
                "filterValue": {
                    "category.level4": [
                        691, 1555, 2059, 2224, 2470, 2471,
                        690, 1430, 1351, 2223, 2469,
                    ]
                }
            },
            "14": {
                "name": "니트조끼",
                "value": 14,
                "filterValue": {
                    "category.level4": [
                        560, 689, 840, 1431, 1554, 2057, 2222, 2468,
                    ]
                }
            },
            "15": {
                "name": "오버사이즈셔츠",
                "value": 15,
                "filterValue": {
                    "category.level4": [
                        692, 1352, 1556, 2472,
                    ]
                }
            }
        }
    },
    "inner": {
        name: 'INNER',
        value: 'inner',
        subInfo: '(티셔츠, 드레스셔츠, 니트, 맨투맨)',
        subCate: {
            "1": {
                "name": "긴팔티셔츠",
                "value": 1,
                "filterValue": {
                    "category.level4": [
                        561, 693, 841, 1432, 1354, 1560, 2473,
                        694, 842, 1561, 2474,
                        562, 695, 843, 1562,
                        696, 1433, 1563,
                        563, 844,
                        564, 698, 845, 1434, 1357, 1565, 2478,
                        1360,
                        2062, 2070, 2067, 2235, 2232, 2227, 2230, 2476,
                    ]
                }
            },
            "2": {
                "name": "반팔티셔츠",
                "value": 2,
                "filterValue": {
                    "category.level4": [
                        581, 710, 858, 1443, 1363, 1577, 2490,
                        711, 859, 1578, 2491,
                        574, 712, 860, 1579, 2492,
                        713, 1444, 1580,
                        576, 862,
                        1336,
                        2087, 2087, 2082, 2247, 2252, 2244, 2250, 2493,
                    ]
                }
            },
            "3": {
                "name": "피케셔츠",
                "value": 3,
                "filterValue": {
                    "category.level4": [
                        701, 1435, 1356, 1568, 2481,
                        718, 864, 1446, 1364, 1585, 2498,
                    ]
                }
            },
            "4": {
                "name": "맨투맨",
                "value": 4,
                "filterValue": {
                    "category.level4": [
                        702, 849, 1436, 1353, 1569, 2071, 2236, 2482,
                        1359,
                    ]
                }
            },
            "5": {
                "name": "후드티",
                "value": 5,
                "filterValue": {
                    "category.level4": [
                        697, 1437, 1355, 1564, 2066, 2231, 2477,
                    ]
                }
            },
            "6": {
                "name": "긴팔셔츠",
                "value": 6,
                "filterValue": {
                    "category.level4": [
                        568, 847,
                        699, 851, 1438, 1566, 2479,
                        703, 850, 1570, 2483,
                        1442, 1358,
                    ]
                }
            },
            "7": {
                "name": "긴팔블라우스",
                "value": 7,
                "filterValue": {
                    "category.level4": [
                        569, 700, 848, 1567, 2480,
                        570
                    ]
                }
            },
            "8": {
                "name": "반팔셔츠",
                "value": 8,
                "filterValue": {
                    "category.level4": [
                        714, 866, 1447, 1581, 2494,
                        1450, 1365,
                    ]
                }
            },
            "9": {
                "name": "반팔블라우스",
                "value": 9,
                "filterValue": {
                    "category.level4": [
                        578,
                        577, 715, 1582, 2495,
                    ]
                }
            },
            "10": {
                "name": "긴팔니트",
                "value": 10,
                "filterValue": {
                    "category.level4": [
                        704, 846, 1571, 2073, 2238, 2484,
                        571, 705, 852, 1439, 1361, 1572, 2074, 2239, 2485,
                        572, 706, 853, 1573, 2075, 2240, 2486,
                        708, 854, 1440, 1575, 2488,
                        565, 855,
                        567, 709, 856, 1441, 1362, 1576, 2078, 2243, 2489,
                        566, 707, 857, 1574,
                    ]
                }
            },
            "11": {
                "name": "슬리브리스",
                "value": 11,
                "filterValue": {
                    "category.level4": [
                        717, 871, 1584,
                        716, 863, 1445, 1496, 1583, 2497,
                    ]
                }
            },
            "12": {
                "name": "반팔니트",
                "value": 12,
                "filterValue": {
                    "category.level4": [
                        723, 865, 1589, 2503,
                        582, 724, 867, 1590, 2504,
                        580, 868,
                        573, 719, 869, 1448, 1367, 1586, 2499,
                        575, 720, 870, 1587, 2500,
                        579, 721, 861, 1588,
                        722, 1449, 2502,
                    ]
                }
            }
        },
    },
    "bottom": {
        name: 'BOTTOM',
        value: 'bottom',
        subInfo: '(팬츠, 스커트, 하프팬츠)',
        subCate: {

            "1": {
                "name": "치노팬츠",
                "value": 1,
                "filterValue": {
                    "category.level4": [
                        738, 880, 1454, 1369, 2516,
                        881, 1453, 1368, 2518,
                        588, 739, 2517,
                    ]
                }
            },
            "2": {
                "name": "슬랙스",
                "value": 2,
                "filterValue": {
                    "category.level4": [
                        583, 725, 872, 2505,
                        584, 726, 873, 2507,
                        585, 727, 2506,
                        586, 728, 2507,
                        587, 729, 874
                    ]
                }
            },
            "3": {
                "name": "청바지",
                "value": 3,
                "filterValue": {
                    "category.level4": [
                        590, 732, 877, 1452, 1371, 2512,
                        591, 733, 876, 1451, 1370, 2515,
                        592, 734, 2513,
                        589, 735, 2514,
                        736, 878,
                    ]
                }
            },
            "4": {
                "name": "카고·조거팬츠",
                "value": 4,
                "filterValue": {
                    "category.level4": [
                        730, 875, 1373,
                        737,
                        1376,
                        1456, 1375,
                        1457, 1374,
                    ]
                }
            },
            "5": {
                "name": "트레이닝팬츠",
                "value": 5,
                "filterValue": {
                    "category.level4": [
                        731, 1455, 1372, 2098, 2264, 2510,
                        593, 741, 2100, 2262, 2508,
                        1377,
                        1380, 2107, 2273, 2523
                    ]
                }
            },
            "6": {
                "name": "반바지",
                "value": 6,
                "filterValue": {
                    "category.level4": [
                        594, 742, 882, 2112, 2519,
                        743, 1379, 2520,
                        747, 1458, 1378, 2524,
                        595, 744, 883, 2521,
                        596, 2522,
                    ]
                }
            },
            "7": {
                "name": "미니 스커트",
                "value": 7,
                "filterValue": {
                    "category.level4": [
                        597, 748, 1383, 2114, 2279, 2525,
                        598, 749, 1382, 2115, 2280, 2526,
                        599, 750, 1384, 2527,
                        1381,
                        600, 2282, 2528,
                    ]
                }
            },
            "8": {
                "name": "미디 스커트",
                "value": 8,
                "filterValue": {
                    "category.level4": [
                        601, 751, 884, 1459, 2118, 2529,
                        602, 752, 885, 2119, 2530,
                        603, 753, 886, 2120, 2531,
                        604, 754, 887, 2122, 2532,
                        606, 756, 2534,
                        605, 757, 2535,
                        607, 2533,
                        755
                    ]
                }
            },
            "9": {
                "name": "롱 스커트",
                "value": 9,
                "filterValue": {
                    "category.level4": [
                        608, 758, 888, 2536,
                        611, 759, 889, 1460, 1386, 2129, 2537,
                        609, 760, 890, 2538,
                        761, 891, 2539,
                        610, 763, 892, 2541,
                        612, 764, 2542,
                        613, 2540,
                        762, 1461, 1385,
                    ]
                }
            }
        },
    },
    "dress": {
        name: 'ONE-PIECE',
        value: 'dress',
        subInfo: '(원피스)',
        subCate: {
            "1": {
                "name": "미니 원피스",
                "value": 1,
                "filterValue": {
                    "category.level4": [
                        1462, 1387, 1614,
                        614, 765, 893, 1388, 1610, 2297, 2543,
                        615, 766, 1389, 1611, 2298, 2544,
                        616, 767, 1612, 2545,
                        1615,
                        1616,
                        768, 1463, 1613, 2300, 2546,
                    ]
                }
            },
            "2": {
                "name": "미디 원피스",
                "value": 2,
                "filterValue": {
                    "category.level4": [
                        1623,
                        617, 770, 894, 1619, 2548,
                        618, 771, 895, 1620, 2549,
                        619, 772, 896, 1621, 2550,
                        773, 897, 1618, 2551,
                        621, 774, 1617, 2552,
                        620, 769, 1622,
                    ]
                }
            },
            "3": {
                "name": "롱 원피스",
                "value": 3,
                "filterValue": {
                    "category.level4": [
                        1464, 1390, 1630,
                        622, 777, 898, 1626, 2555,
                        623, 778, 899, 1465, 1391, 1627, 2556,
                        624, 779, 900, 1628, 2557,
                        625, 780, 901, 1629, 2558,
                        776, 902, 1466, 1625, 2554,
                        626, 775, 1624, 2553,
                    ]
                }
            }
        },
    },
    "shoes": {
        name: 'SHOES',
        value: 'shoes',
        subInfo: '',
        subCate: {
            "1": {
                "name": "구두",
                "value": 1,
                "filterValue": {
                    "category.level4": [
                        785, 1635, 2563,
                        788, 1640,
                    ]
                }
            },
            "2": {
                "name": "더비슈즈",
                "value": 2,
                "filterValue": {
                    "category.level4": [
                        907, 1469, 1392,
                    ]
                }
            },
            "3": {
                "name": "힐",
                "value": 3,
                "filterValue": {
                    "category.level4": [
                        1490, 1636,
                        629, 1638,
                    ]
                }
            },
            "4": {
                "name": "슬링백",
                "value": 4,
                "filterValue": {
                    "category.level4": [
                        628, 786, 903, 1637, 2564,
                    ]
                }
            },
            "5": {
                "name": "로퍼",
                "value": 5,
                "filterValue": {
                    "category.level4": [
                        636, 787, 911, 1470, 1639, 2154, 2565,
                        790, 1471, 1642,
                        632, 789, 1641, 2156, 2567,
                    ]
                }
            },
            "6": {
                "name": "부츠·워커",
                "value": 6,
                "filterValue": {
                    "category.level4": [
                        637, 794, 912, 1646, 2570,
                        795, 1473, 1395, 2571,
                        796, 1474, 2572,
                        638, 797, 913, 1475, 1647, 2573,
                        798, 914, 1396, 1648, 2574,
                    ]
                }
            },
            "7": {
                "name": "플랫슈즈",
                "value": 7,
                "filterValue": {
                    "category.level4": [
                        634, 792, 909, 1472, 1644, 2158, 2569,
                        635, 793, 910, 1645,
                    ]
                }
            },
            "8": {
                "name": "스니커즈",
                "value": 8,
                "filterValue": {
                    "category.level4": [
                        627, 799, 915, 1476, 1397, 1649, 2329, 2575,
                    ]
                }
            },
            "9": {
                "name": "러닝화",
                "value": 9,
                "filterValue": {
                    "category.level4": [
                        800, 1477, 1398, 1650, 2576,
                    ]
                }
            },
            "10": {
                "name": "어글리·하이탑",
                "value": 10,
                "filterValue": {
                    "category.level4": [
                        801, 1399, 1651,
                        1400,
                    ]
                }
            },
            "11": {
                "name": "블로퍼·뮬",
                "value": 11,
                "filterValue": {
                    "category.level4": [
                        633, 791, 908, 1643, 2157, 2568,
                        631, 783, 904, 1633, 2561,
                    ]
                }
            },
            "12": {
                "name": "슬리퍼·샌들",
                "value": 12,
                "filterValue": {
                    "category.level4": [
                        1491, 784, 905, 1468, 1394, 1634, 2316, 2562,
                        630, 782, 1632, 2560,
                        781, 906, 1467, 1393, 1631, 2559,
                    ]
                }
            }
        },
    },
    "bag": {
        name: 'BAG',
        value: 'bag',
        subInfo: '',
        subCate: {
            "1": {
                "name": "백팩",
                "value": 1,
                "filterValue": {
                    "category.level4": [
                        802, 1478, 1401, 1652, 2578,
                    ]
                }
            },
            "2": {
                "name": "크로스백",
                "value": 2,
                "filterValue": {
                    "category.level4": [
                        639, 803, 916, 1402, 1653, 2579,
                    ]
                }
            },
            "3": {
                "name": "메신저·슬링백",
                "value": 3,
                "filterValue": {
                    "category.level4": [
                        804, 920, 1479, 1403, 1654, 2582,
                    ]
                }
            },
            "4": {
                "name": "클러치·핸드백",
                "value": 4,
                "filterValue": {
                    "category.level4": [
                        640, 805, 1655, 2588,
                        809, 1659,
                    ]
                }
            },
            "5": {
                "name": "토트백",
                "value": 5,
                "filterValue": {
                    "category.level4": [
                        641, 806, 917, 1480, 1656, 2580,
                        642, 810, 919, 1660, 2583,
                    ]
                }
            },
            "6": {
                "name": "에코백",
                "value": 6,
                "filterValue": {
                    "category.level4": [
                        807, 918, 1481, 1657, 2581,
                    ]
                }
            },
            "7": {
                "name": "버킷백",
                "value": 7,
                "filterValue": {
                    "category.level4": [
                        643, 811, 921, 1661, 2584,
                    ]
                }
            },
            "8": {
                "name": "기타",
                "value": 8,
                "filterValue": {
                    "category.level4": [
                        808, 1658, 2175, 2340,
                        2177,
                        2174,
                        2339,
                        2332,
                    ]
                }
            }
        },
    },
    "acc": {
        name: 'ACC',
        value: 'acc',
        subInfo: '',
        subCate: {
            "1": {
                "name": "모자",
                "value": 1,
                "filterValue": {
                    "category.level4": [
                        1591,
                        1592,
                        1593, 2586,
                    ]
                }
            },
            "2": {
                "name": "스카프",
                "value": 2,
                "filterValue": {
                    "category.level4": [
                        1594,
                    ]
                }
            },
            "3": {
                "name": "액세서리",
                "value": 3,
                "filterValue": {
                    "category.level4": [
                        1595, 2585,
                        1596,
                        1597,
                        1598,
                        1599,
                    ]
                }
            },
            "4": {
                "name": "아이웨어",
                "value": 4,
                "filterValue": {
                    "category.level4": [
                        1600, 2587,
                    ]
                }
            },
        },
    },
}

export const cateManFilter = {
    "outer": {
        name: 'OUTER',
        value: 'outer',
        subInfo: '(코트, 패딩, 외 겨울 아우터)',
        subCate: {
            "1": {
                "name": "코트",
                "value": 1,
                "filterValue": {
                    "category.level4": [
                        282, 389, 1267,
                        283, 390, 1266,
                        327, 387, 1200, 2343,
                        328, 388,
                        285, 329, 386, 1268,
                        286, 330, 1265,
                        287, 331, 1270,
                    ]
                }
            },
            "2": {
                "name": "간절기코트",
                "value": 2,
                "filterValue": {
                    "category.level4": [
                        284, 1487, 385,
                        1482, 1486, 1489, 1269,
                    ]
                }
            },
            "3": {
                "name": "패딩",
                "value": 3,
                "filterValue": {
                    "category.level4": [
                        333, 1202, 1853, 1934, 2345,
                        334, 391, 1272, 1204, 1855, 1936, 2347,
                    ]
                }
            },
            "4": {
                "name": "겨울점퍼",
                "value": 4,
                "filterValue": {
                    "category.level4": [
                        332, 1271, 1201, 1852, 1933, 2344,
                        335, 1273, 1203, 1854, 1935, 2346,
                    ]
                }
            },
            "5": {
                "name": "무스탕",
                "value": 5,
                "filterValue": {
                    "category.level4": [
                        392, 1274, 1205, 2348,
                    ]
                }
            }
        },
    },
    "top": {
        name: 'TOP',
        value: 'top',
        subInfo: '(자켓, 가디건, 블루종, 트러커)',
        subCate: {

            "1": {
                "name": "블레이저",
                "value": 1,
                "filterValue": {
                    "category.level4": [
                        288, 1275,
                        289,
                        395, 1206, 2349,
                        394,
                        1494,
                        1497,
                    ]
                }
            },
            "2": {
                "name": "라이더자켓",
                "value": 2,
                "filterValue": {
                    "category.level4": [
                        337, 393, 1278,
                    ]
                }
            },
            "3": {
                "name": "필드자켓",
                "value": 3,
                "filterValue": {
                    "category.level4": [
                        291, 336, 1276, 1207, 2350,
                        290, 1277,
                        1279,
                    ]
                }
            },
            "4": {
                "name": "블루종",
                "value": 4,
                "filterValue": {
                    "category.level4": [
                        343, 1280, 1213, 1945, 2356,
                        292, 338, 396, 1208, 1859, 2351,
                    ]
                }
            },
            "5": {
                "name": "점퍼",
                "value": 5,
                "filterValue": {
                    "category.level4": [
                        340, 1282, 1210, 1868, 1949, 2353,
                        339, 1209, 1941, 2352,
                        345, 1215, 1864, 1947, 2358,
                        294,
                    ]
                }
            },
            "6": {
                "name": "플리스",
                "value": 6,
                "filterValue": {
                    "category.level4": [
                        342, 1284, 1212, 1863, 1944, 2355,
                    ]
                }
            },
            "7": {
                "name": "아노락",
                "value": 7,
                "filterValue": {
                    "category.level4": [
                        1285, 1216, 1867, 1948, 2359,
                    ]
                }
            },
            "8": {
                "name": "트러커",
                "value": 8,
                "filterValue": {
                    "category.level4": [
                        344, 397, 1281, 1214, 2357,
                    ]
                }
            },
            "9": {
                "name": "집업후드",
                "value": 9,
                "filterValue": {
                    "category.level4": [
                        341, 1283, 1211, 1943, 1862, 1943, 2354,
                    ]
                }
            },
            "10": {
                "name": "가디건",
                "value": 10,
                "filterValue": {
                    "category.level4": [
                        293, 346, 398, 1286, 1217, 1869, 1950, 2361,
                    ]
                }
            },
            "11": {
                "name": "조끼",
                "value": 11,
                "filterValue": {
                    "category.level4": [
                        295, 348, 1288, 1218, 1872, 1953, 2364,
                        1871, 1951, 2363,
                        347, 1287, 1219, 1870, 1954, 2365,
                    ]
                }
            },
            "12": {
                "name": "오버사이즈셔츠",
                "value": 12,
                "filterValue": {
                    "category.level4": [
                        349, 399, 1220, 2366,
                    ]
                }
            },
        },
    },
    "inner": {
        name: 'INNER',
        value: 'inner',
        subInfo: '(티셔츠, 드레스셔츠, 니트, 맨투맨)',
        subCate: {
            "1": {
                "name": "긴팔티셔츠",
                "value": 1,
                "filterValue": {
                    "category.level4": [
                        351, 400, 1290, 1222, 1876, 2368,
                        352,
                        355, 402, 1294,
                        354, 401, 1293, 1225, 1960, 2371,
                    ]
                }
            },
            "2": {
                "name": "긴팔",
                "value": 2,
                "filterValue": {
                    "category.level4": [
                        1880, 1961, 2372,
                    ]
                }

            },
            "3": {
                "name": "반팔",
                "value": 3,
                "filterValue": {
                    "category.level4": [
                        1888, 1888, 2380,
                    ]
                }

            },
            "4": {
                "name": "반팔티셔츠",
                "value": 4,
                "filterValue": {
                    "category.level4": [
                        359, 410, 1303, 1233, 2381,
                        360,
                        361, 1304,
                    ]
                }
            },
            "5": {
                "name": "피케셔츠",
                "value": 5,
                "filterValue": {
                    "category.level4": [
                        296, 1292, 1224, 1878, 1959, 2370,
                        303, 1495, 1234, 1890, 1971, 2382,
                    ]
                }
            },
            "6": {
                "name": "맨투맨",
                "value": 6,
                "filterValue": {
                    "category.level4": [
                        350, 1289, 1221, 1875, 1956, 2367,
                        1228,
                    ]
                }
            },
            "7": {
                "name": "후드티",
                "value": 7,
                "filterValue": {
                    "category.level4": [
                        353, 1291, 1223, 1877, 1958, 2369,
                    ]
                }
            },
            "8": {
                "name": "긴팔셔츠",
                "value": 8,
                "filterValue": {
                    "category.level4": [
                        297, 403,
                        356, 404, 1295, 1226, 2373,
                        298, 405, 1296, 1227, 2374,
                        406, 1297,
                    ]
                }
            },
            "9": {
                "name": "반팔·여름셔츠",
                "value": 9,
                "filterValue": {
                    "category.level4": [
                        305,
                        362, 1305, 1235, 2384,
                        411, 1306, 1236, 2385,
                        363, 413, 1309,
                    ]
                }
            },
            "10": {
                "name": "긴팔니트",
                "value": 10,
                "filterValue": {
                    "category.level4": [
                        300, 357, 407, 1298, 1229, 2376,
                        301, 408, 1299, 1230, 2377,
                        302, 358, 409, 1300, 1231, 2378,
                        1302,
                        299, 1301, 1232, 2379,
                    ]
                }
            },
            "11": {
                "name": "반팔니트",
                "value": 11,
                "filterValue": {
                    "category.level4": [
                        304, 1308, 1237, 2386,
                        306, 412, 1307, 2383,
                    ]
                }
            }
        },
    },
    "bottom": {
        name: 'BOTTOM',
        value: 'bottom',
        subInfo: '(팬츠, 스커트, 하프팬츠)',
        subCate: {

            "1": {
                "name": "치노팬츠",
                "value": 1,
                "filterValue": {
                    "category.level4": [
                        312, 366, 419, 2389,
                        311, 364, 417, 1311, 1239, 2388,
                        365, 418, 1310, 1238, 2387,
                    ]
                }
            },
            "2": {
                "name": "슬랙스",
                "value": 2,
                "filterValue": {
                    "category.level4": [
                        308, 414,
                        307, 416,
                        415,
                    ]
                }
            },
            "3": {
                "name": "청바지",
                "value": 3,
                "filterValue": {
                    "category.level4": [
                        310, 369, 422, 2392,
                        309, 367, 420, 1313, 1241, 2391,
                        368, 421, 1312, 1240, 2390,
                    ]
                }
            },
            "4": {
                "name": "트레이닝팬츠",
                "value": 4,
                "filterValue": {
                    "category.level4": [
                        1314, 1242, 1983, 2394,
                        1247, 2399,
                        1250, 1994,
                    ]
                }
            },
            "5": {
                "name": "카고·조거팬츠",
                "value": 5,
                "filterValue": {
                    "category.level4": [
                        1317, 1246,
                        1316, 1245,
                        1315, 1244,
                        370, 423, 1243, 1984,
                    ]
                }
            },
            "6": {
                "name": "반바지",
                "value": 6,
                "filterValue": {
                    "category.level4": [
                        313, 425, 2402,
                        372, 1319, 1249, 2404,
                        314, 371, 424, 1318, 1248, 2400,
                    ]
                }
            },
            "7": {
                "name": "긴바지",
                "value": 7,
                "filterValue": {
                    "category.level4": [
                        1901, 1982, 2393,
                    ],
                },
            },
        },
    },
    "shoes": {
        name: 'SHOES',
        value: 'shoes',
        subInfo: '',
        subCate: {
            "1": {
                "name": "구두",
                "value": 1,
                "filterValue": {
                    "category.level4": [
                        315,
                        316, 373, 426, 1320, 1251, 2406,
                        317,
                        1484,
                    ]
                }
            },
            "2": {
                "name": "로퍼",
                "value": 2,
                "filterValue": {
                    "category.level4": [
                        318, 427, 1321,
                        320,
                        319, 1252, 2407,
                        428,
                    ]
                }
            },
            "3": {
                "name": "부츠·워커",
                "value": 3,
                "filterValue": {
                    "category.level4": [
                        1322, 1253, 2408,
                        1483, 374, 429, 2410,
                        321, 1323, 2409,
                    ]
                }
            },
            "4": {
                "name": "스니커즈",
                "value": 4,
                "filterValue": {
                    "category.level4": [
                        322, 375, 430, 1324, 1254, 2000, 2411,
                    ]
                }
            },
            "5": {
                "name": "러닝화",
                "value": 5,
                "filterValue": {
                    "category.level4": [
                        376, 1325, 1255, 2412,
                    ]
                }
            },
            "6": {
                "name": "어글리·하이탑",
                "value": 6,
                "filterValue": {
                    "category.level4": [
                        377, 431, 1256,
                        1257,
                    ]
                }
            },
            "7": {
                "name": "슬리퍼·샌들",
                "value": 7,
                "filterValue": {
                    "category.level4": [
                        378, 432, 1326, 1258, 2415,
                        1327, 1259, 2416,
                    ]
                }
            }
        },
    },
    "bag": {
        name: 'BAG',
        value: 'bag',
        subInfo: '',
        subCate: {
            "1": {
                "name": "백팩",
                "value": 1,
                "filterValue": {
                    "category.level4": [
                        379, 436, 1328, 1260, 2417,
                    ]
                }
            },
            "2": {
                "name": "메신저백",
                "value": 2,
                "filterValue": {
                    "category.level4": [
                        380, 1329, 1261, 2418,
                        381, 434, 1262,
                    ]
                }
            },
            "3": {
                "name": "클러치",
                "value": 3,
                "filterValue": {
                    "category.level4": [
                        323, 433, 2423,
                    ]
                }
            },
            "4": {
                "name": "토트백·브리프케이스",
                "value": 4,
                "filterValue": {
                    "category.level4": [
                        324, 382, 435, 1330, 2421,
                        325,
                        1485,
                    ]
                }
            },
            "5": {
                "name": "에코백",
                "value": 5,
                "filterValue": {
                    "category.level4": [
                        383, 1331, 2419,
                    ]
                }
            },
            "6": {
                "name": "기타",
                "value": 6,
                "filterValue": {
                    "category.level4": [
                        1929, 2010, 2420,
                        1930,
                        1928,
                        1914,
                        1931,
                        2009,
                        2011,
                        2006,
                    ]
                }
            }
        },
    }
};
